// angular
// 	.module("HeroPRO")
// 	.controller("AssignJobController", assignJobController);

import _ from 'lodash';
import './assignJob.scss';

/* @ngInject */
export default function assignJobController($rootScope, JobFactory, UserData, raSpinnerService, ModalService, $analytics) {
    const vm = this;

    vm.selectedLocation = {};
    vm.selectedSalesRep = {};
    vm.locations = [];
    vm.salesReps = [];
    vm.loading = true;
    vm.isAssignmentDisabled = true;
    vm.activeJob = {};
    vm.originalLocationId = null;
    vm.originalSalesRepId = null;

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.locationClicked = function (item) {
        vm.selectedLocation = item;
        getSalesReps();
    };

    vm.salesRepClicked = function (item) {
        vm.selectedSalesRep = item;
        vm.isAssignmentDisabled = validateSelections();
    };

    vm.submitAssignment = function (isValid) {
        if (isValid) {
            raSpinnerService.show('jobSpinner');
            let params = {};
            if (vm.activeJob.PreQualId !== undefined && vm.activeJob.PreQualId !== null && vm.activeJob.PreQualId !== '') {
                params = {
                    PreQualId: vm.activeJob.PreQualId,
                    ContractorUserId: vm.selectedSalesRep.ContractorUserId,
                    ContractorLocationId: vm.selectedLocation.ContractorId,
                };
                JobFactory.assignLead(params).then(() => {
                    $rootScope.$broadcast('pipelineJobAssignment', {
                        data: {
                            PreQualId: vm.activeJob.PreQualId,
                            Location: vm.selectedLocation.LocationNickname,
                            SalesRepName: `${vm.selectedSalesRep.FirstName} ${vm.selectedSalesRep.LastName}`,
                        },
                    });
                    raSpinnerService.hide('jobSpinner');
                    raSpinnerService._unregister('jobSpinner');
                    ModalService.closeLgModal();
                });
            } else {
                params = {
                    FundingRequestId: vm.activeJob.FundingRequestId,
                    ContractorUserId: vm.selectedSalesRep.ContractorUserId,
                    ContractorLocationId: vm.selectedLocation.ContractorId,
                };
                JobFactory.assignApplication(params).then(() => {
                    $rootScope.$broadcast('pipelineJobAssignment', {
                        data: {
                            FundingRequestId: vm.activeJob.FundingRequestId,
                            Location: vm.selectedLocation.LocationNickname,
                            SalesRepName: `${vm.selectedSalesRep.FirstName} ${vm.selectedSalesRep.LastName}`,
                        },
                    });
                    raSpinnerService.hide('jobSpinner');
                    raSpinnerService._unregister('jobSpinner');
                    ModalService.closeLgModal();
                });
            }

            $analytics.eventTrack('Assign Job Clicked', { category: 'AssignJob' });
        }
    };

    vm.cancelAssignment = function () {
        raSpinnerService._unregister('jobSpinner');
        ModalService.closeLgModal();
    };

    vm.jobSpinnerLoaded = function () {
        raSpinnerService.show('jobSpinner');
    };

    vm.showSpinner = function () {
        if (raSpinnerService.isRegistered('jobSpinner')) {
            raSpinnerService.show('jobSpinner');
        } else {
            raSpinnerService._register('jobSpinner');
            raSpinnerService.show('jobSpinner');
        }
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        getLocations();
        vm.activeJob = JobFactory.getActiveJob();
    }

    function getLocations() {
        UserData.getKBYGLocations().then((response) => {
            vm.locations = response;
            let activeLocation = {};
            if (vm.activeJob.ContractorId !== undefined && vm.activeJob.ContractorId !== null && vm.activeJob.ContractorId !== '') {
                activeLocation = _.where(vm.locations, { ContractorId: vm.activeJob.ContractorId });
                vm.selectedLocation = activeLocation[0];
            } else if (vm.activeJob.ContractorLocationId !== undefined && vm.activeJob.ContractorLocationId !== null && vm.activeJob.ContractorLocationId !== '') {
                activeLocation = _.where(vm.locations, { ContractorId: vm.activeJob.ContractorLocationId });
                vm.selectedLocation = activeLocation[0];
            } else {
                vm.selectedLocation = vm.locations[0];
            }

            if (vm.originalLocationId === null) {
                vm.originalLocationId = vm.selectedLocation.ContractorId;
            }

            vm.isAssignmentDisabled = validateSelections();

            getSalesReps();
        });
    }

    function getSalesReps() {
        JobFactory.getSalesReps(vm.selectedLocation.ContractorId).then((result) => {
            vm.salesReps = result.data.Data;
            if (vm.activeJob.ContractorUserId !== undefined && vm.activeJob.ContractorUserId !== null && vm.activeJob.ContractorUserId !== '') {
                const activeRep = _.where(vm.salesReps, { ContractorUserId: vm.activeJob.ContractorUserId });

                if (activeRep.length === 0) {
                    vm.selectedSalesRep = vm.salesReps[0];
                } else {
                    vm.selectedSalesRep = activeRep[0];
                }
            } else {
                vm.selectedSalesRep = vm.salesReps[0];
            }

            if (vm.originalSalesRepId === null) {
                vm.originalSalesRepId = vm.selectedSalesRep.ContractorUserId;
            }

            vm.isAssignmentDisabled = validateSelections();

            raSpinnerService.hide('jobSpinner');
        });
    }

    function validateSelections() {
        return vm.selectedLocation.ContractorId === vm.originalLocationId && vm.selectedSalesRep.ContractorUserId === vm.originalSalesRepId;
    }
}



// WEBPACK FOOTER //
// ./src/app/common/job/assign/assignJobController.js